import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const GrievancePolicy: React.FC = () => (
  <PolicyPage slug="grievance-policy" subtitle="Grievance Policy" />
);

export default GrievancePolicy;
